'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminAutorisationsController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {

  var API = '/api/autorisations-recherche';

  $scope.autorisations = [];
  $scope.isLoading     = true;
  $scope.showModal     = false;
  $scope.saving        = false;
  $scope.currentPage   = 1;
  $scope.itemsPerPage  = 10;
  $scope.totalItems    = 0;
  $scope.totalPages    = 0;
  $scope.searchQuery   = '';
  $scope.filterStatut  = '';
  $scope.editingAuth   = {};
  $scope.successMsg    = '';
  $scope.errorMsg      = '';

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  function filterLocal(list) {
    var q = ($scope.searchQuery || '').toLowerCase();
    var s = $scope.filterStatut;
    return list.filter(function(a) {
      var matchQ = !q || (a.denomination || '').toLowerCase().indexOf(q) !== -1 || (a.reference || '').toLowerCase().indexOf(q) !== -1;
      var matchS = !s || a.statut === s;
      return matchQ && matchS;
    });
  }

  $scope.load = function() {
    $scope.isLoading = true;
    $http.get(API)
      .then(function(res) {
        var all = Array.isArray(res.data) ? res.data : (res.data.content || []);
        var filtered = filterLocal(all);
        $scope.totalItems = filtered.length;
        $scope.totalPages = Math.ceil(filtered.length / $scope.itemsPerPage) || 1;
        var start = ($scope.currentPage - 1) * $scope.itemsPerPage;
        $scope.autorisations = filtered.slice(start, start + $scope.itemsPerPage);
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des autorisations.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { $scope.currentPage = 1; $scope.load(); }, 350);
  };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p;
    $scope.load();
  };

  $scope.getPages = function() {
    var pages = [], s = Math.max(1, $scope.currentPage - 2), e = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = s; i <= e; i++) pages.push(i);
    return pages;
  };

  $scope.openModal = function(a) {
    $scope.editingAuth = a ? angular.copy(a) : { statut: 'En vigueur' };
    $scope.showModal   = true;
  };

  $scope.closeModal = function() { $scope.showModal = false; $scope.editingAuth = {}; };

  $scope.saveAutorisation = function() {
    if (!$scope.editingAuth.denomination) { flash('errorMsg', 'La dénomination est obligatoire.'); return; }
    $scope.saving = true;
    var req = $scope.editingAuth.id
      ? $http.put(API + '/' + $scope.editingAuth.id, $scope.editingAuth)
      : $http.post(API, $scope.editingAuth);
    req.then(function() {
      $scope.closeModal(); $scope.load();
      flash('successMsg', $scope.editingAuth.id ? 'Autorisation mise à jour.' : 'Autorisation créée.');
    })
    .catch(function() { flash('errorMsg', 'Erreur lors de l\'enregistrement.'); })
    .finally(function() { $scope.saving = false; });
  };

  $scope.deleteAutorisation = function(a) {
    if (!confirm('Supprimer l\'autorisation de "' + a.denomination + '" ?')) return;
    $http.delete(API + '/' + a.id)
      .then(function() { $scope.load(); flash('successMsg', 'Autorisation supprimée.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  $scope.load();
}]);
